export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: 'ID코드' }, { name: '성명' }, { name: '성별' }, { name: '직종' }, { name: '소속명(담당자)' }, { name: '부서명(담당자)' }, { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).inputA_5 // ID코드
      case 2: return func.onNameBlur(func.getContent(value).inputA_6) // 성명
      case 3: return func.getContent(value).inputA_7 // 성별
      case 4: return func.getContent(value).inputA_9 // 직종
      case 5: return func.getContent(value).stdInfo.department // 소속명
      case 6: return func.getContent(value).stdInfo.section // 부서명
      case 7: return func.getContent(value).stdInfo.writer_name // 작성자
      case 8: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.stdInfo."재해형태"*[:default_disaster]')

    switch (nav.value.searchType) {
    case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case 'ID코드': returnData.push('content$body.stdInfo."inputA_5"*%[:default_skw]%'); break
    case '성명': returnData.push('content$body.stdInfo."inputA_6"*%[:default_skw]%'); break
    case '성별': returnData.push('content$body.stdInfo."inputA_7"*%[:default_skw]%'); break
    case '직종': returnData.push('content$body.stdInfo."inputA_9"*%[:default_skw]%'); break
    case '소속명(담당자)': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '부서명(담당자)': returnData.push('content$body.stdInfo.section*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
